import { render, staticRenderFns } from "./IniciarRequisicao.vue?vue&type=template&id=473de35c&"
import script from "./IniciarRequisicao.vue?vue&type=script&lang=js&"
export * from "./IniciarRequisicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports